import { GlobalAction, VideoDeletesState } from '.';

const GET_VIDEO_DELETES_START = 'GET_VIDEO_DELETES_START';
const GET_VIDEO_DELETES_ERROR = 'GET_VIDEO_DELETES_ERROR';
const GET_VIDEO_DELETES_SUCCESS = 'GET_VIDEO_DELETES_SUCCESS';
const ADD_VIDEO_DELETES_START = 'ADD_VIDEO_DELETES_START';
const ADD_VIDEO_DELETES_ERROR = 'ADD_VIDEO_DELETES_ERROR';
const ADD_VIDEO_DELETES_SUCCESS = 'ADD_VIDEO_DELETES_SUCCESS';
const EDIT_VIDEO_DELETES_START = 'EDIT_VIDEO_DELETES_START';
const EDIT_VIDEO_DELETES_ERROR = 'EDIT_VIDEO_DELETES_ERROR';
const EDIT_VIDEO_DELETES_SUCCESS = 'EDIT_VIDEO_DELETES_SUCCESS';
const DELETE_VIDEO_DELETES_START = 'DELETE_VIDEO_DELETES_START';
const DELETE_VIDEO_DELETES_ERROR = 'DELETE_VIDEO_DELETES_ERROR';
const DELETE_VIDEO_DELETES_SUCCESS = 'DELETE_VIDEO_DELETES_SUCCESS';
const ADD_STOP_VIDEO_DELETES_START = 'ADD_STOP_VIDEO_DELETES_START';
const ADD_STOP_VIDEO_DELETES_ERROR = 'ADD_STOP_VIDEO_DELETES_ERROR';
const ADD_STOP_VIDEO_DELETES_SUCCESS = 'ADD_STOP_VIDEO_DELETES_SUCCESS';

export const videoDeletesReducer = (
  state: VideoDeletesState,
  action: GlobalAction
): VideoDeletesState => {
  const { payload, type } = action;
  switch (type) {
    case GET_VIDEO_DELETES_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_VIDEO_DELETES_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_VIDEO_DELETES_SUCCESS: {
      return {
        ...state,
        videoDelete: payload.videoDelete,
        loading: false,
      };
    }
    case ADD_VIDEO_DELETES_SUCCESS: {
      return {
        ...state,
        videoDelete: {
          ...state.videoDelete,
          ...payload.videoDelete,
        },
      };
    }
    case EDIT_VIDEO_DELETES_SUCCESS: {
      return {
        ...state,
        videoDelete: {
          ...state.videoDelete,
          ...payload.videoDelete,
        },
      };
    }
    case DELETE_VIDEO_DELETES_SUCCESS: {
      return { ...state, videoDelete: {} };
    }
    case ADD_STOP_VIDEO_DELETES_SUCCESS: {
      const stopRequests = (
        (state.videoDelete && state.videoDelete.stopRequests) ||
        []
      ).concat([payload.stopVideoDeleteRequest]);
      return {
        ...state,
        videoDelete: {
          ...state.videoDelete,
          stopRequests,
        },
      };
    }
    default:
      return state;
  }
};

export const VIDEO_DELETES_ACTIONS = {
  GET_VIDEO_DELETES_START,
  GET_VIDEO_DELETES_ERROR,
  GET_VIDEO_DELETES_SUCCESS,
  ADD_VIDEO_DELETES_START,
  ADD_VIDEO_DELETES_ERROR,
  ADD_VIDEO_DELETES_SUCCESS,
  EDIT_VIDEO_DELETES_START,
  EDIT_VIDEO_DELETES_ERROR,
  EDIT_VIDEO_DELETES_SUCCESS,
  DELETE_VIDEO_DELETES_START,
  DELETE_VIDEO_DELETES_ERROR,
  DELETE_VIDEO_DELETES_SUCCESS,
  ADD_STOP_VIDEO_DELETES_START,
  ADD_STOP_VIDEO_DELETES_ERROR,
  ADD_STOP_VIDEO_DELETES_SUCCESS,
};
